export default __webpack_public_path__ + "static/profile-pic-6-4c48baeec7c1b0c4485fc118985040c9.jpeg";